/**
 * Composable useSupportContact — логика контакта с поддержкой
 *
 * Централизует открытие Telegram-чата и Email для поддержки.
 * Используется в SupportButton и BottomNav.
 */

// Composable для буфера обмена — @vueuse/core
import { useClipboard } from '@vueuse/core'
// Стор пользователя — telegramID для подстановки в сообщение
import { useUserStore } from '@/modules/user/stores/userStore'
// Стор настроек — username бота поддержки, email
import { useSettingsStore } from '@/modules/settings/store/settingsStore'
// Стор обратной связи — тост-уведомления
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
// Утилита определения Telegram-контекста
import { isTelegram } from '@/utils/isTelegram'
import { tGlobal } from '@/plugins/i18n'

/**
 * Composable для контакта с поддержкой
 *
 * @returns contactViaTelegram, contactViaEmail
 */
export const useSupportContact = () => {
  // Инициализация сторов
  const userStore = useUserStore()
  const settingsStore = useSettingsStore()
  const feedbackStore = useFeedbackStore()
  // Composable для копирования в буфер
  const { copy } = useClipboard()

  /**
   * Открывает Telegram-чат с ботом поддержки
   * Прокидывает telegramID пользователя в сообщение
   */
  const contactViaTelegram = () => {
    const supportUsername = settingsStore.supportBotUsername
    const tgId = userStore.user?.telegramID
    const message = `My tgID: ${tgId}`
    const encodedMessage = encodeURI(message)
    window.open(`https://t.me/${supportUsername}?text=${encodedMessage}`, '_blank')
  }

  /**
   * Открывает почтовый клиент или копирует email в буфер
   * В Telegram WebView mailto: не работает — копируем email + тост
   */
  const contactViaEmail = async () => {
    const email = settingsStore.supportEmail
    if (isTelegram()) {
      // В Telegram WebView mailto: не работает — копируем email в буфер
      await copy(email)
      feedbackStore.showToast({ type: 'info', message: tGlobal('support.emailCopied', { email }) })
    } else {
      // В веб-версии — открываем почтовый клиент
      const tgId = userStore.user?.telegramID
      const subject = encodeURIComponent(tGlobal('support.title'))
      const body = encodeURIComponent(`My tgID: ${tgId}`)
      window.open(`mailto:${email}?subject=${subject}&body=${body}`)
    }
  }

  return { contactViaTelegram, contactViaEmail }
}
